import { FILTER_CONFIG_NAMES } from './DataConstants';

export const getPMScheduleTemplateFilterConfig = ({ filters }: { filters: any }) => {
	return [filters[FILTER_CONFIG_NAMES.PROBLEM_TYPE]].filter(Boolean);
};
